// @core/api/endpoints/workflow/get_pipeline_run_as_request.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineRunAsRequestResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get an execution identity request
 * Retrieves pipeline run as request by the specified identifier.
 */
export async function GetPipelineRunAsRequest(
  request_id: string,
  options?: RequestOptions
): Promise<PipelineRunAsRequestResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/run-as-requests/:request_id`;
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.get<PipelineRunAsRequestResponse>(requestPath, { ...requestOptions });
}
